import { useState, useEffect, useRef } from "react";
export default function SpecializedCareIntro() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Inter:wght@300;400;600;700&display=swap');`}</style>
      <div className="px-6 md:px-8" style={{
      paddingTop: "clamp(96px, 10vw, 128px)",
      paddingBottom: "clamp(96px, 10vw, 128px)"
    }}>
        <div ref={ref} className={`flex flex-col items-center text-center mx-auto transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        maxWidth: "672px"
      }}>
          <p style={{
          color: "#E51F26",
          fontFamily: "Inter, system-ui, -apple-system, sans-serif",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          textAlign: "center",
          marginBottom: "14px"
        }}>
            PREMIER MEDICAL EQUIPMENT PROVIDER
          </p>

          <h2 style={{
          color: "rgb(26, 26, 26)",
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontSize: "48px",
          fontWeight: "500",
          lineHeight: "60px",
          letterSpacing: "-1.2px",
          border: "0px solid rgb(26, 26, 26)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          margin: 0
        }}>
            Specialized care for complex conditions.
          </h2>

          <div style={{
          width: "44px",
          height: "2px",
          backgroundColor: "#E51F26",
          marginTop: "20px",
          marginBottom: "24px",
          flexShrink: 0
        }} />

          <p style={{
          color: "oklch(0.446 0.03 256.802)",
          fontFamily: "Inter, system-ui, -apple-system, sans-serif",
          fontSize: "18px",
          fontWeight: "300",
          lineHeight: "29.25px",
          border: "0px solid oklch(0.446 0.03 256.802)",
          textAlign: "center",
          animation: "none 0s ease 0s 1 normal none running",
          margin: 0
        }}>
            REM Technologies offers specialized medical equipment tailored for a comprehensive range of health conditions. We combine deep clinical expertise with innovative practices to advance health outcomes for patients and the providers who care for them.
          </p>
        </div>
      </div>
    </section>;
}